import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  resultTable: {
    margin: "10px 25px 25px 25px !important",
    width: "100%",
    borderCollapse: "collapse",
  },
  thHeader: {
    backgroundColor: theme.palette.header,
    color: theme.palette.amano.base.main,
    fontWeight: "bold",
  },
  centerAlign: {
    textAlign: "center",
  },
  checkIcon: {
    color: theme.palette.success.main,
  },
  unpaidIcon: {
    color: theme.palette.error.main,
  },
  centerHeader: {
    textAlign: "center !important",
    verticalAlign: "middle",
  },
  clickableRow: {
   "&:hover": {
      backgroundColor: "rgba(217, 212, 212, 0.178)",
      cursor: "pointer",
    },
  },
  waitTimeLabel: {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 4,
    minWidth: 32,
    textAlign: "center",
  },
  waitTimeLabelColored: {
    color: theme.palette.common.white,
  },
}));
